function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 100vw;\n  background-color: ", ";\n  left: 0;\n  right: 0;\n  top: 0;\n  position: fixed;\n\n  ul,\n  li {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  ul {\n    padding: 0 1rem;\n\n    background-color: white;\n    ", " {\n      padding-bottom: 5rem;\n    }\n  }\n\n  li {\n    line-height: 3.75rem;\n    margin: 0 1rem 0;\n    border-bottom: 0.0625rem solid ", ";\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    &:first-child {\n      border-top: 0.0625rem solid ", ";\n    }\n\n    > a,\n    > span.header__nav-link {\n      padding: 0 0 0 2.5rem;\n    }\n\n    > a,\n    > span {\n      font-size: ", ";\n      font-family: ", ";\n      font-weight: ", ";\n\n      &,\n      &:hover,\n      &:visited {\n        color: ", ";\n        text-decoration: none;\n      }\n\n      &.header__nav-link--active {\n        font-weight: ", ";\n      }\n    }\n  }\n\n  ", "\n\n  ", " {\n    ", " {\n      li {\n        line-height: 2.86;\n\n        > a,\n        > span {\n          font-size: ", ";\n        }\n\n        > a {\n          padding-right: 0.625rem;\n          padding-left: 0.625rem;\n        }\n      }\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: none !important;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    position: static;\n    width: auto;\n\n    ul {\n      display: flex;\n      flex-wrap: nowrap;\n      border: 0;\n      padding: 0 0.7rem;\n      justify-content: center;\n    }\n\n    li {\n      border: 0;\n      position: relative;\n      border-bottom: none;\n      line-height: 2;\n      margin: 0;\n\n      &:first-child {\n        border-top: none;\n      }\n\n      > a {\n        padding: 0 0.25rem 0;\n      }\n\n      > a,\n      > span {\n        font-family: ", ";\n        font-size: ", ";\n        font-weight: ", ";\n        display: inline-flex;\n        align-items: center;\n        flex-direction: column;\n\n        &::after {\n          display: block;\n          content: '';\n          height: 0.125rem;\n          width: 0%;\n          background-color: ", ";\n          transition: width 0.3s ease-in-out;\n        }\n\n        &:hover,\n        &.header__nav-link--active {\n          &::after {\n            width: 2.1875rem;\n          }\n        }\n\n        &.header__nav-link--active {\n          font-weight: ", ";\n        }\n      }\n    }\n  }\n\n  ", " {\n    li {\n      > a {\n        padding: 0 0.5rem 0;\n      }\n\n      > a,\n      > span {\n        font-size: ", ";\n      }\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n  padding-right: 1rem;\n  align-items: center;\n\n  ", " {\n    margin-left: auto;\n  }\n\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  &::after {\n    content: '';\n    display: block;\n    margin-left: auto;\n    background-image: url(", ");\n    transform-origin: center;\n    height: 1.125rem;\n    width: 1.125rem;\n    transform: rotateZ(-90deg);\n  }\n\n  ", " {\n    display: none !important;\n\n    &::after {\n      display: none !important;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { AppIconStyle } from "../../appIcon/AppIcon.styles";
import styled, { css, from, to } from "../../../theme";
import { Link } from "../../link/Link";
export var HeaderNavLink = styled(Link)(_templateObject(), function (props) {
  return props.hasSubLinks ? 'none' : 'flex';
});
export var HeaderNavButton = styled.span(_templateObject2(), function (props) {
  return props.theme.variables.icons.svg.chevronM;
}, from('lg'));
export var MobileNavHeader = styled.div(_templateObject3(), function (props) {
  return props.theme.variables.colors.silver;
}, AppIconStyle, from('lg'));
var DesktopLinksList = css(_templateObject4(), from('lg'), function (props) {
  return props.theme.variables.typography.secondaryFont;
}, function (props) {
  return props.theme.variables.fonts.size.smaller0;
}, function (props) {
  return props.theme.variables.fonts.weight.regular;
}, function (props) {
  return props.theme.variables.customColors.leadingColor.base;
}, function (props) {
  return props.theme.variables.fonts.weight.semiBold;
}, from('vlg'), function (props) {
  return props.theme.variables.fonts.size.bigger0;
});
export var HeaderSubWrapper = styled.ul(_templateObject5(), to('lg'));
export var HeaderNavContainer = styled.div(_templateObject6());
export var HeaderNavWrapper = styled.nav(_templateObject7(), function (props) {
  return props.theme.variables.colors.white;
}, to('lg'), function (props) {
  return props.theme.variables.colors.platinum;
}, function (props) {
  return props.theme.variables.colors.platinum;
}, function (props) {
  return props.theme.variables.fonts.size.bigger0;
}, function (props) {
  return props.theme.variables.typography.secondaryFont;
}, function (props) {
  return props.theme.variables.fonts.weight.light;
}, function (props) {
  return props.theme.variables.colors.black;
}, function (props) {
  return props.theme.variables.fonts.weight.semiBold;
}, DesktopLinksList, HeaderSubWrapper, from('lg'), function (props) {
  return props.theme.variables.fonts.size.smaller0;
});